import axios from "axios";
import getAuthorizationToken from "../authToken";
import store from "../../store";

const loading = "SET_LOADING";

// ===============================
// REQUEST COUNTER
// ===============================
let activeRequests = 0;

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

instance.interceptors.request.use(
  config => {
    let token = getAuthorizationToken();
    if (token) config.headers.Authorization = token;

    // Tambah counter request
    activeRequests++;

    // Jika sebelumnya 0 → berarti mulai request pertama → show loading
    if (activeRequests === 1) {
      store.commit(loading, true);
    }

    return config;
  },
  err => {
    // Jika request gagal sebelum terkirim pun tetap kurangi counter
    activeRequests--;

    if (activeRequests === 0) {
      store.commit(loading, false);
    }

    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  response => {
    // Kurangi counter
    activeRequests--;

    // Jika semua request selesai → hide loading
    if (activeRequests === 0) {
      store.commit(loading, false);
    }

    store.commit("SET_AUTHERROR", null);

    return response;
  },
  err => {
    // Kurangi counter (PENTING)
    activeRequests--;

    if (activeRequests === 0) {
      store.commit(loading, false);
    }

    // Handle auth error
    if (err.response && err.response.status) {
      if (err.response.status === 403) {
        store.commit("SET_AUTHERROR", "Unauthorized");
      } else if (err.response.status === 469) {
        store.commit("SET_AUTHERROR", err.response.data.message);
      } else if (err.response.status === 440) {
        store.commit("SET_AUTHERROR", "Sesi login Anda telah berakhir. Silakan login kembali!");
      }
    }
    return Promise.reject(err);
  }
);
export default instance;
